(() => {
  const BRHCta = () => {
    const init = () => {
      const ctaButtons = document.querySelectorAll(".JS-brh-cta-modal-button .JS-launcher-CTA");
      const modalSection = document.querySelector(".js-brh-modal-section");
      const modalContainer = modalSection.querySelector(".js-brh-modal-container");

      ctaButtons.forEach((ctaButton) => {
        const ctaUrl = ctaButton.dataset.modalUrl.concat("/jcr:content/root.html");
        ctaButton.onclick = function () {
          fetch(ctaUrl)
            .then((response) => {
              return response.text();
            })
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              doc.querySelector("main") ? modalContainer.insertAdjacentHTML("beforeend", doc.querySelector("main").innerHTML) : modalContainer.insertAdjacentHTML("beforeend", doc.body.innerHTML);
            })
            .catch((err) => console.error(err));

          modalSection.style.display = "block";
          modalSection.parentElement.style.display = "block";
          document.body.classList.add("mod--menu-open");
        };
      });
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", BRHCta);
})();
